module.exports = __webpack_public_path__ + "static/media/buysellads.19566df8.svg";